import { useParams } from "react-router-dom";
import { useApi } from "../lib/api";
import type { EnvelopeView } from "../lib/types";
import { ErrorNote, Spinner } from "../components/ui";
import Editor from "./Editor";
import EnvelopeStatus from "./EnvelopeStatus";

/** Drafts open in the editor; everything else shows its status and audit trail. */
export default function EnvelopePage({ admin }: { admin?: boolean }) {
  const { id } = useParams();
  const { data, error, loading, reload, setData } = useApi<EnvelopeView>(admin ? `/admin/envelopes/${id}` : `/envelopes/${id}`);
  if (loading && !data) return <Spinner />;
  if (error && !data)
    return (
      <div className="max-w-3xl mx-auto p-4">
        <ErrorNote>{error}</ErrorNote>
      </div>
    );
  if (!data) return null;
  if (data.envelope.status === "draft" && !admin) return <Editor key={data.envelope.id} initial={data} onSent={(v) => setData(v)} />;
  return <EnvelopeStatus view={data} admin={admin} reload={reload} />;
}
